import {InjectionToken} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export const OVERLAY_CDK_CONTAINER = new InjectionToken<BehaviorSubject<any>>(
  'OVERLAY_CDK_CONTAINER'
);
